import { Injectable, signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private _isLoading = signal(false)
  private _message = signal<string>('CARGANDO')

  readonly isLoading = this._isLoading.asReadonly()
  readonly message = this._message.asReadonly()

  show(customMessage: string = 'CARGANDO'): void {
    this._message.set(customMessage)
    this._isLoading.set(true)
  }

  hide() {
    this._isLoading.set(false)
  }
}
